module.exports = __webpack_public_path__ + "img/particle_motion_00108.6fa51d8b.png";